import { Box, IconContainerProps, Rating } from "@mui/material";
import SentimentVeryDissatisfiedIcon from "@mui/icons-material/SentimentVeryDissatisfied";
import SentimentDissatisfiedIcon from "@mui/icons-material/SentimentDissatisfied";
import SentimentSatisfiedIcon from "@mui/icons-material/SentimentSatisfied";
import SentimentSatisfiedAltIcon from "@mui/icons-material/SentimentSatisfiedAltOutlined";
import SentimentVerySatisfiedIcon from "@mui/icons-material/SentimentVerySatisfied";
import { useRatingCsatStyles } from "./RatingCsat.style";
import { styled } from "@mui/material/styles";

interface IProps {
	ratingValue: number | null;
	setRatingValue: (value: number) => void;
}

const StyledRating = styled(Rating)(({ theme }) => ({
	"& .MuiRating-iconEmpty .MuiSvgIcon-root": {
		color: theme.palette.action.disabled,
	},
}));

const customIcons: {
	icon: React.ReactElement;
	label: string;
}[] = [
	{
		icon: <SentimentVeryDissatisfiedIcon color="error" fontSize="large" />,
		label: "1",
	},
	{
		icon: <SentimentDissatisfiedIcon color="error" fontSize="large" />,
		label: "2",
	},
	{
		icon: <SentimentSatisfiedIcon color="warning" fontSize="large" />,
		label: "3",
	},
	{
		icon: <SentimentSatisfiedAltIcon color="success" fontSize="large" />,
		label: "4",
	},
	{
		icon: <SentimentVerySatisfiedIcon color="success" fontSize="large" />,
		label: "5",
	},
];

function IconContainer(props: IconContainerProps) {
	const { value, ...other } = props;
	return <span {...other}>{customIcons[value - 1].icon}</span>;
}

const RatingCsat = ({ ratingValue, setRatingValue }: IProps) => {
	const { classes } = useRatingCsatStyles();

	return (
		<Box className={classes.buttonsWrapper}>
			<StyledRating
				name="highlight-selected-only"
				defaultValue={ratingValue || undefined}
				IconContainerComponent={IconContainer}
				getLabelText={(value: number) => customIcons[value - 1].label}
				highlightSelectedOnly
				onChange={(_, newValue) => newValue && setRatingValue(newValue)}
			/>
		</Box>
	);
};

export default RatingCsat;
